
const initialState = {
    agencies: JSON.parse(localStorage.getItem("agencies")) || {},
    profiles: JSON.parse(localStorage.getItem("profiles")) || {},
    profilesSearch: JSON.parse(localStorage.getItem("profiles")) || {},
    carrierGroup: JSON.parse(localStorage.getItem("carriergroups")) || {},
    allCarrier: [],
    allGroupCarrier:[],
    allProfile:[],
    allSearch:[],
    allError:null,
    error: null,
    loggedInUser: [],
    get_all_locations_list: [],
    selecte_user_profile: [],
    searched_user_list:[],
    get_all_carrier_list: [],
    user_info: [],
    get_all_manage_carrier_listing: [],
    get_carrier_list: [],
    get_user_name_list: null,
    state_carrier_list: [],
    carrier_group_list: [],
    search_carrier_list: [],
    user_permission: [],
    user_all_permission: []
  };

  const agencyReducer = (state = initialState, action) => {
    switch (action.type) {
      case "ALL_CARRIER_INFOS_SUCCESS":
        return { ...state, allCarrier: action.payload, error: null };
        
        case "GET_SEARCH_USER_NAME_SUCCESS":
        return { ...state, get_user_name_list: action.payload, error: null };

        case "GET_USER_PERMISSION_SCCUESS":
        return { ...state, user_permission: action.payload, error: null };  
        
         case "GET_USER_ALL_PERMISSION_SCCUESS":
        return { ...state, user_all_permission: action.payload, error: null }; 

        case "GET_COMPANY_GROUPS_SUCCESS":
        return { ...state, carrier_group_list: action.payload, error: null };

         case "GET_CARRIER_LIST_WITH_STATE_SUCCESS":
        return { ...state, state_carrier_list: action.payload, error: null };

        case "GET_ALL_CARRIER_INFOS_SUCCESS":
        return { ...state, get_all_carrier_list: action.payload, error: null };        
        
        case "UPDATE_INSURANCE_CARRIER":
        return { ...state, allCarrier: action.payload, error: null };

        case "DELETE_CARRIER_LISTING_ITEM_SUCCESS":
        return { ...state, allCarrier: action.payload, error: null };

        case "CLEAR_CARRIER_LISTING_ITEM_SUCCESS":
        return { ...state, allCarrier: [], error: null };

        case "LOGGEDIN_USER_PROFILE_SUCCESS":
        return { ...state, loggedInUser: action.payload, error: null };

        case "GET_ALL_LOCATIONS_SUCCESS":
        return { ...state, get_all_locations_list: action.payload, error: null };

        case "GET_ALL_SEARCH_USER_SUCCESS":
        return { ...state, allProfile: action.payload, error: null };

        case "GET_USER_INFO_SUCCESS":
        return { ...state, user_info: action.payload, error: null };
        
      case "ALL_CARRIER_GROUP_INFOS_SUCCESS":
        return { ...state, allGroupCarrier: action.payload, error: null };
      case "ALL_PROFILE_INFOS_SUCCESS":
        return { ...state, allProfile: action.payload, error: null };
        case "DELETE_USER_PROFILE":
        return { ...state, allProfile: action.payload, error: null };
        case "GET_USER_DETAILS_SUCCESS":
          return { ...state, selecte_user_profile: action.payload, error: null };
      case "SEARCH_AGENCY_SUCCESS":
        return { ...state, allSearch: action.payload, error: null };
      case "GET_SEARCH_CARRIER_LIST_SUCCESS":
      return { ...state, get_all_manage_carrier_listing: action.payload, error: null };
       case "SAVE_CARRIER_GROUP_SUCCESS":
        localStorage.setItem("carriergroups", JSON.stringify(action.payload));
        return { ...state, carrierGroup: action.payload, error: null };
      case "SAVE_AGENCY_SUCCESS":
        localStorage.setItem("agencies", JSON.stringify(action.payload));
        return { ...state, agencies: action.payload, error: null };
       case "SAVE_PROFILE_SUCCESS":
        localStorage.setItem("profiles", JSON.stringify(action.payload));
        return { ...state, profiles: action.payload, error: null };
       case "SAVE_PROFILE_SEARCH_SUCCESS":
        localStorage.setItem("profilesSearch", JSON.stringify(action.payload));
        return { ...state, profilesSearch: action.payload, error: null };
      case "UPDATE_CARRIER_SUCCESS":
        localStorage.setItem("agencies", JSON.stringify(action.payload));
        return { ...state, agencies: action.payload, error: null };
      case "UPDATE_PROFILE_SUCCESS":
        localStorage.setItem("profiles", JSON.stringify(action.payload));
        return { ...state, profiles: action.payload, error: null };
     case "DELETE_AGENCY_SUCCESS":
      const updatedNote = state.allNote.filter(
      (policy) => policy.id !== action.payload
      );
     return { ...state, allNote: updatedNote, error: null };
      case "GET_SEARCH_MANAGE_CARRIER_LISTING_SUCCESS":
          return { ...state, get_all_manage_carrier_listing: action.payload, error: null }; 
      case "GET_SEARCH_CARRIER_RESULT_LIST_SUCCESS":
          return { ...state, get_carrier_list: action.payload, error: null }; 

      case "GET_SEARCH_CARRIER_LIST_FAILURE":
      case "ALL_AGENCY_INFOS_FAILURE":
      case "ALL_PROFILE_INFOS_FAILURE":
      case "ALL_CARRIER_INFOS_FAILURE":
      case "ALL_CARRIER_GROUP_INFOS_FAILURE":
      case "SAVE_AGENCY_FAILURE":
      case "SAVE_PROFILE_FAILURE":
        return { ...state, allError: action.payload };
      case "SAVE_PROFILE_SEARCH_FAILURE":
      case "GET_USER_ALL_PERMISSION_FAILURE":
      case "GET_USER_PERMISSION_FAILURE":        
      case "SEARCH_AGENCY_FAILURE":
      case "SAVE_CARRIER_GROUP_FAILURE":
      case "DELETE_AGENCY_FAILURE":
      case "UPDATE_PROFILE_FAILURE":
      case "UPDATE_CARRIER_FAILURE":
      case "DELETE_CARRIER_LISTING_ITEM_FAILURE":
      case "GET_SEARCH_MANAGE_CARRIER_LISTING_FAILURE":
        return { ...state, error: action.payload };
      default:
        return state;
    }
  };

  export default agencyReducer;
